import React from 'react'
import CaseCitation from './CaseCitation'

const CaseBillItem = ({ item }) => {
  const { amount, description } = item

  return (
    <>
      {!item.citation
        ? (
        <div className="bg-white rounded-lg p-2.5 text-gray-600 mb-2">
          <div className="flex justify-between">
            <span>{description}</span>
            <span className="font-bold">{`$${amount}`}</span>
          </div>
        </div>
          )
        : (
        <CaseCitation citation={item.citation} />
          )}
    </>
  )
}

export default CaseBillItem
